import TransactionsCharts from './transactionsCharts';

export * from './existingRealties';
export * from './ownersByAge';
export * from './ownersByConsumptionPattern';
export * from './ownersByMaritalStatus';
export * from './ownersByMonthlyIncome';
export * from './ownersBySchooling';
export * from './pricePerSqMtMedian';
export * from './transactionedOverExistingRealties';

export default TransactionsCharts;
